import { motion } from "framer-motion";

/**
 * FadeUp — a reusable scroll-in reveal.
 * Use as a wrapper around any block that should animate on scroll.
 */
export function FadeUp({
  children,
  delay = 0,
  y = 32,
  duration = 0.9,
  className = "",
  once = true,
  amount = 0.25,
  ...rest
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ delay, duration, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

/**
 * MaskLine — masked line reveal. Each line rises from below its container.
 * Split your text into words/lines by wrapping each in its own <MaskLine>.
 */
export function MaskLine({
  children,
  delay = 0,
  duration = 0.9,
  className = "",
}) {
  return (
    <span
      className={`line-mask ${className}`}
      style={{ display: "block", overflow: "hidden" }}
    >
      <motion.span
        style={{ display: "inline-block" }}
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{
          delay,
          duration,
          ease: [0.22, 1, 0.36, 1],
        }}
      >
        {children}
      </motion.span>
    </span>
  );
}
